export const cloudProviders = ['aws', 'azure'] as const;
export type CloudProvider = (typeof cloudProviders)[number];

export const ARDOQ_REFERENCE_DATA = 'ardoq-reference-data';

export const unifiedIntegrationProviders = [
  'ardoq',
  ARDOQ_REFERENCE_DATA,
  'ardoq-sample-data',
  'sharepoint-files',
  'jira-software',
  'entra-id',
  'signavio',
  'celonis',
  'symbio',
  'import-builder',
  'azure-resources',
] as const;

export type UnifiedIntegrationProvider =
  (typeof unifiedIntegrationProviders)[number];

export type SourceType =
  | UnifiedIntegrationProvider
  | 'servicenow'
  | 'microsoftgraph'
  | 'azure'
  | 'aws'
  | 'itpedia'
  | 'signavio-exporter'
  | 'sheets'
  | 'excel'
  | 'csv'
  | 'celonis-exporter'
  | 'servicenow-guided-exporter'
  | 'servicenow-export'
  | 'json'
  | 'import-api';

export const otherIntegrationProviders = ['servicenow'] as const;

export const allIntegrationProviders = [
  ...cloudProviders,
  ...unifiedIntegrationProviders,
  ...otherIntegrationProviders,
] as const;

export type IntegrationProvider = (typeof allIntegrationProviders)[number];

export function isCloudProvider(
  provider: IntegrationProvider
): provider is CloudProvider {
  return cloudProviders.includes(provider as CloudProvider);
}

export function isUnifiedIntegrationProvider(
  provider: IntegrationProvider
): provider is UnifiedIntegrationProvider {
  return unifiedIntegrationProviders.includes(
    provider as UnifiedIntegrationProvider
  );
}
